import { downloadFile } from '../file.platform';
import { createToast } from '../toasts.platform';
import { exportDocuments } from './export';

export default async function exportDocumentsToFile() {
  const content = await exportDocuments();
  await downloadFile('export.csv', content, 'text/csv');
  createToast({ content: 'CSV ready to download', category: 'success' });
}
